<div class="container-fluid mb-0 pl-0 pr-0 pt-0">
  <div class="row">
    <div class="col">
      <h6 class="font-weight-light page-header pt-0" style="margin-left: 15px; margin-top: 2px;">{{ 'orgmemberlist.orgmembers' | trans }}</h6>
      <p class="page-header-sub" style="margin-left: 15px;">{{ 'orgmemberlist.orgmemberssub' | trans }}</p>
    </div>
    <div *ngIf="canAddMember()" class="col-auto">
      <div class="cursor-pointer col pr-0">
        <button matTooltip="{{ 'orgmemberlist.createusertip' | trans }}" aria-label="create user" matTooltipPosition="above" matTooltipShowDelay="1000"
         data-toggle="modal" data-target="#createorgMember" style="margin-top: 6px;" class="btn-empty border-0 mobile-reverse-toggle" type="button" 
          aria-haspopup="true" aria-expanded="false">
          <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn portal-icon p-0 center cursor-pointer">
            add
            </span>
        </button>
    </div>
    </div>
  </div>
  
<div class="card border-0">
    <div class="card-body p-0">
      <div class="card p-0 no-border">
        <!-- <div *ngFor="let pers of members" class="row mobile-nav-toggle " style="background-color: #fafafa; border: 1px solid #f2f2f2; border-radius: 10px; margin-bottom: 5px; margin-left: 1vw; margin-right: 1vw;">
          <div (click)="onClick(pers.personId)" data-toggle="modal" data-target="#orgmemberlistModal" class="col" >
            <p style="line-height: 50px; vertical-align: middle; margin-bottom: 0px; font-size: 14px; font-weight: 500; ">
              {{ pers.membername }}
            </p>
          </div>
          <div (click)="onClick(pers.personId)" data-toggle="modal" data-target="#orgmemberlistModal" class="col">
            <p style="line-height: 50px; vertical-align: middle; margin-bottom: 0px; font-size: 14px; font-weight: 500; ">
              {{ pers.membername }}
            </p>
          </div>
        </div> -->
        <!-- <div class="row mobile-nav-toggle btn" *ngIf="canAddMember()" style="border: 1px solid #f2f2f2; border-radius: 10px; margin-bottom: 5px; margin-left: 1vw; margin-right: 1vw;">
          <div data-toggle="modal" data-target="#createorgMember" class="col">
            <p class="btn-text" style="line-height: 30px; vertical-align: middle; margin-bottom: 0px; font-size: 14px; font-weight: 500; ">
              Create new person
            </p>
          </div>
        </div> -->
        <div class="rounded bg-secondary w-100">
          <div *ngFor="let pers of members" class="row mr-0 ml-0 opacity ">
            <div class="col-auto pt-2 pr-0">
              <app-personimage [bigimg]="false" [enableChange]="false" [personId]="pers.personId"></app-personimage>
            </div>
            <div class="col-4 col-sm-3 my-auto align-middle pl-3">
              <a (click)="onClick(pers.personId)" data-toggle="modal" data-target="#orgmemberlistModal" matTooltip="{{ 'orgmemberlist.showdetails' | trans }} {{ pers.membername }}" matTooltipPosition="above" matTooltipShowDelay="1000">
                <h6 class="align-middle lh-58 my-auto text-truncate cursor-pointer">{{ pers.membername }}</h6></a>
            </div>
            <div class="col-1 col-sm-2 my-auto d-none d-md-block align-middle">
              <a (click)="onClick(pers.personId)" data-toggle="modal" data-target="#orgmemberlistModal">
                <p class="cursor-pointer align-middle text-truncate my-auto lh-58">{{ 'orgmemberlist.joined' | trans }} {{ pers.date_joined | date:'yyyy-MM-dd' }}</p>
              </a>
            </div>
            <div class="col-1 col-sm-2 my-auto d-none d-sm-block align-middle">
              <a (click)="onClick(pers.personId)" data-toggle="modal" data-target="#orgmemberlistModal">
                <p class="cursor-pointer align-middle text-truncate my-auto lh-58">{{ pers.phone }}</p>
              </a>
            </div>
            <div class="col-2 col-sm-2 my-auto d-none d-sm-block align-middle">
              <a (click)="onClick(pers.personId)" data-toggle="modal" data-target="#orgmemberlistModal">
                <p class="cursor-pointer align-middle text-truncate my-auto lh-58">{{ pers.email }}</p>
              </a>
            </div>
            <div class="col-2 col-sm-2 my-auto align-middle">
              <a (click)="onClick(pers.personId)" data-toggle="modal" data-target="#orgmemberlistModal">
                <p class="cursor-pointer align-middle my-auto text-truncate lh-58">{{ pers.member_function }}</p>
              </a>
            </div>
          </div>
        </div>
        </div>
          <div class="container">
            <div id="orgmemberlistModal" class="modal fade" role="dialog">
                <app-personmodal (personOutput)="updateList($event)" [showPending]="false" [modalpersonId]="modalpersonId" [modalorgId]="modalorgId"></app-personmodal>
            </div>    
          </div>
          <div  class="container">
            <div id="createorgMember" class="modal fade" role="dialog">
             <app-orguseradd (memberToAdd)="addNewMemberToList($event)"></app-orguseradd>
            </div>    
          </div>
        </div>
    </div>
</div>
